export const getProductUrl = ({
  slug,
  isCollectionProduct = false,
}: { slug: string; isCollectionProduct?: boolean }) => {
  const page = isCollectionProduct ? `/collection/${slug}` : `/product/${slug}`;
  const baseUrl = process.env.NEXT_PUBLIC_HOME_LINK ?? '';
  return `${baseUrl}${page}`;
};

export const getFullSku = ({ sku, promocode }: { sku: string; promocode?: string }) => {
  if (promocode) {
    return `${sku.trim()} ${promocode.trim()}`;
  }

  return sku.trim();
};
